import React from "react";

export default function BetweenOperatorComp({
  maxValue,
  setMaxValue,
  minValue,
  setMinValue,
  selectedOperator,
}) {
  const handleMinValueChange = (e) => {
    const value = e.target.value;
    if (value === "") {
      setMinValue("");
    } else if (!isNaN(value)) {
      setMinValue(Number(value));
    }
  };

  const handleMaxValueChange = (e) => {
    const value = e.target.value;
    // console.log(value);
    if (value === "") {
      setMaxValue("");
    } else if (!isNaN(value)) {
      // console.log("dsa");
      setMaxValue(Number(value));
    }
  };

  return (
    <main className="flex flex-col gap-2 my-2 items-start justify-center px-2 w-full">
      <section className="flex gap-2 items-center justify-center">
        <label>Min Value: </label>
        <input
          type="number"
          value={minValue}
          onChange={handleMinValueChange}
          className="border-b-[2px] border-[0.5px] rounded border-blue-950 px-1"
          required
        />
      </section>
      {selectedOperator === "BETWEEN" && (
        <section className="flex gap-2 items-center justify-center">
          <label>Max Value: </label>
          <input
            type="number"
            value={maxValue}
            onChange={handleMaxValueChange}
            className="border-b-[2px] border-[0.5px] rounded border-blue-950 px-1"
            required
          />
        </section>
      )}
    </main>
  );
}
